import script from "./customGoogleLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./customGoogleLogin.vue?vue&type=script&setup=true&lang=ts"

import "./customGoogleLogin.vue?vue&type=style&index=0&id=b542a9d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b542a9d8"]])

export default __exports__